<template>
	<!-- Modal Component Search Rep-->
	<b-modal
			id="updateRepModal"
			ref="updateRepModal"
			centered
			hide-header-close
			no-close-on-backdrop
			no-close-on-esc
			no-enforce-focus
			no-stacking
			ok-only
			ok-title="Actualizar"
			size="xl"
			title="Actualización de Datos"
			@ok="handleOk"
	>
		<!--<form method="POST" v-on:submit.prevent="updateRep(fillRep.contractNumber)">-->
		<b-form @submit.stop.prevent="handleOk">
			<b-form-row>
				<b-form-group
						id="zone"
						label="Zona"
						label-for="Zona"
						class="col-2 col-sm-2 col-md-2 col-lg-1"
				>
					<b-form-input
							v-model="objRep.zone"
							class="form-control"
							name="zone"
							readonly="readonly"
							type="text"
					/>
				</b-form-group>
				<b-form-group
						id="estatus"
						label="Estatus"
						label-for="Estatus"
						class="col-2 col-sm-2 col-md-2 col-lg-1"
				>
					<b-form-input
							v-model="objRep.status"
							class="form-control"
							name="status"
							readonly="readonly"
							type="text"
					/>
				</b-form-group>
				<b-form-group
						id="grupo"
						label="Grupo"
						label-for="Grupo"
						class="col-2 col-sm-2 col-md-2 col-lg-1"
				>
					<b-form-input
							v-model="objRep.group"
							class="form-control"
							name="group"
							readonly="readonly"
							type="text"
					/>
				</b-form-group>
				<b-form-group
						id="contractNumber"
						label="N° Contrato"
						label-for="N° Contrato"
						class="col-6 col-sm-6 col-md-6 col-lg-2"
				>
					<b-form-input
							v-model="objRep.contractNumber"
							class="form-control"
							name="contractNumber"
							readonly="readonly"
							type="text"
					/>
				</b-form-group>
				<b-form-group
						id="fullName"
						label="Nombre Representante"
						label-for="Nombre Representante"
						class="col-12 col-sm-12 col-md-12 col-lg-7"
				>
					<b-form-input
							v-model="fullName"
							class="form-control"
							name="fullName"
							readonly="readonly"
							type="text"
					/>
				</b-form-group>
			</b-form-row>
			<b-form-row>
				<b-form-group
						id="lblemail"
						label="Email"
						label-for="Email"
						class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-4"
				>
					<b-form-input
							id="email"
							ref="email"
							v-model="objRep.email"
							v-validate="'required|email'"
							:state="validateState('email')"
							aria-describedby="emailLiveFeedback"
							:formatter="toLowerCase"
							placeholder="Ejemplo: representante@avon.com"
							data-vv-as="Email"
							name="email"
							type="email"
					/>
					<b-form-invalid-feedback id="emailLiveFeedback">
						{{ errors.first("email") }}
					</b-form-invalid-feedback>
				</b-form-group>
				<b-form-group
						id="lblEmail_confirmation"
						label="Confirmación del Email"
						label-for="lblEmail_confirmation"
						class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-4"
				>
					<b-form-input
							id="email_confirmation"
							ref="email_confirmation"
							v-model="email_confirmation"
							v-validate="'required|confirmed:email'"
							:state="validateState('email_confirmation')"
							aria-describedby="emailConfirmationLiveFeedback"
							:formatter="toLowerCase"
							data-vv-as="Confirmación de Email"
							name="email_confirmation"
							type="email"
					/>
					<b-form-invalid-feedback id="emailConfirmationLiveFeedback">
						{{ errors.first("email_confirmation") }}
					</b-form-invalid-feedback>
				</b-form-group>
				<b-form-group
						id="lblOperadoraCelular"
						label="Numero de Teléfono Celular"
						label-for="lblOperadoraCelular"
						class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4"
				>
					<b-input-group>
						<b-input-group-prepend>
							<b-form-select
									id="areaCode"
									ref="areaCode"
									v-model="objRep.areaCode"
									v-validate="'required'"
									:options="phoneOperators"
									:state="validateState('areaCode')"
									aria-describedby="areaCodeLiveFeedback"
									data-vv-as="Operadora Celular"
									name="areaCode"
							/>
						</b-input-group-prepend>
						<b-form-input
								id="phoneNumber"
								ref="phoneNumber"
								v-model="objRep.phoneNumber"
								v-validate="'required|digits:7'"
								:state="validateState('phoneNumber')"
								aria-describedby="phoneNumberLiveFeedback"
								data-vv-as="Número Telefónico"
								maxlength="7"
								name="phoneNumber"
								number
								type="text"
						/>
						<b-form-invalid-feedback id="phoneNumberLiveFeedback">
							{{ errors.first("phoneNumber") }}
						</b-form-invalid-feedback>
					</b-input-group>
				</b-form-group>
			</b-form-row>
		</b-form>
		<div slot="modal-footer" class="w-100">
			<b-button
					class="float-right"
					size="sm"
					variant="success"
					@click="handleOk"
			>
				Actualizar sus Datos
			</b-button>
		</div>
	</b-modal>
</template>

<script>
	import {mapState, mapMutations} from "vuex";

	export default {
		name: "UpdateRep",
		props: {
			objRep: {
				type: Object,
				required: true
			}
		},
		data: function () {
			return {
				error: 0,
				email_confirmation: "",
				phoneOperators: [
					{value: "0412", text: "0412"},
					{value: "0414", text: "0414"},
					{value: "0424", text: "0424"},
					{value: "0416", text: "0416"},
					{value: "0426", text: "0426"}
				]
			};
		},
		computed: {
			...mapState(["wasUpdated"]),
			fullName() {
				return this.objRep.firstName + " " + this.objRep.lastName;
			}
		},
		methods: {
			...mapMutations(["SET_WASUPDATED"]),
			toLowerCase(value, event) {
				return value.toLowerCase();
			},
			validateState: function (ref) {
				if (
						this.fields[ref] &&
						(this.fields[ref].touched || this.fields[ref].validated)
				) {
					return !this.errors.has(ref);
				}
				return null;
			},
			handleOk: function (evt) {
				evt.preventDefault();

				this.$validator.validate().then(valid => {
					if (valid) {
						if (
								this.objRep.email === this.email_confirmation &&
								this.objRep.areaCode !== "" &&
								this.objRep.phoneNumber !== ""
						) {
							this.handleSubmit();
						} else {
							alert("Por favor corrija los datos proporcionados");
						}
					}
				});
			},
			handleSubmit: function () {
				// Preparing to Submmit Data
				// Adding email_confirmation field to $requesto to must be send it to server
				this.$set(this.objRep, "email_confirmation", this.email_confirmation);

				// Calling updateRep to send it
				this.updateRep(this.objRep.contractNumber);
			},
			updateRep: function (contractNumber) {
				var urlApi = "/rep/" + contractNumber;

				this.axios
						.put(urlApi, this.objRep)
						.then(response => {
							if (response.status === 200) {
								this.$toastr(
										"success",
										"Registro actualizado con éxito",
										"Operación Exitosa"
								);
								this.SET_WASUPDATED(true);

								this.$cookie.set(
										"AvonRep",
										{updated: true, when: Date()},
										{expires: 30, domain: "localhost"}
								);

								this.$refs.updateRepModal.hide();
								Promise.resolve();
							}
						})
						.catch(error => {
							this.errorNro = error.response.status;
							//console.log(error);

							if (this.errorNro === 404) {
								this.$toastr(
										"error",
										"N° de Contrato No Existe o es Invalido...",
										"Error"
								);
							} else if (this.errorNro === 408 || this.errorNro >= 500) {
								this.$toastr(
										"error",
										"Ha ocurrido un error de comunicación...",
										"Error"
								);
							} else if (this.errorNro >= 503) {
								this.$toastr(
										"error",
										"Servicio No Disponible, Intente más tarde",
										"Error"
								);
							} else {
								this.$toastr(
										"error",
										"Ha ocurrido un error, intente mas tarde...",
										"Error"
								);
							}
							Promise.resolve();
						});
			}
		}
	};
</script>

<style scoped></style>
